import { Scale } from 'lucide-react';
import { useCompare } from '@/contexts/CompareContext';

const CompareButton = ({ property, size = "default", className = "" }) => {
  const { isInCompare, toggleCompare, compareCount, maxCompare } = useCompare();
  const isActive = isInCompare(property.id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleCompare(property);
  };

  const sizeClasses = {
    small: "w-8 h-8",
    default: "w-10 h-10",
    large: "w-12 h-12"
  };

  const iconSizes = {
    small: 14,
    default: 18,
    large: 22
  };

  return (
    <button
      onClick={handleClick}
      disabled={!isActive && compareCount >= maxCompare}
      className={`
        ${sizeClasses[size]} 
        flex items-center justify-center rounded-full 
        transition-all duration-300 
        ${isActive 
          ? 'bg-[#D4AF37] text-black' 
          : compareCount >= maxCompare
            ? 'bg-black/40 text-white/30 cursor-not-allowed'
            : 'bg-black/60 text-white hover:bg-black/80'
        }
        ${className}
      `}
      title={isActive ? 'Quitar de comparación' : compareCount >= maxCompare ? 'Máximo alcanzado' : 'Añadir a comparación'}
      data-testid={`compare-btn-${property.id}`}
    >
      <Scale size={iconSizes[size]} />
    </button>
  );
};

export default CompareButton;
